import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const requestCode = gql`
  mutation RequestAuthCodeMutation($contact: String!) {
    authentication {
      requestVerificationCode(input: { source: $contact }) {
        type
        source
      }
    }
  }
`;

export const verifyCode = gql`
  mutation VerifyAuthCodeMutation(
    $contact: String!
    $code: String!
    $inviteCode: String
    $referrer: String
  ) {
    authentication {
      verifyCode(
        input: { source: $contact, code: $code, inviteCode: $inviteCode, referrer: $referrer }
      ) {
        authToken
        isInvitedUserOnFirstVisit
        user {
          ...User
        }
      }
    }
  }

  ${Fragments.user.normal}
`;

export const acceptInvite = gql`
  mutation AcceptBusinessInviteMutation($inviteCode: String!) {
    authentication {
      acceptInvite(inviteCode: $inviteCode) {
        ...User
      }
    }
  }

  ${Fragments.user.normal}
`;

export const addTokenMutation = gql`
  mutation AddUserPushTokenMutation($input: UserPushTokenInput!) {
    addUserPushToken(input: $input) {
      success
    }
  }
`;
